/* tslint:disable */
/* eslint-disable */
/**
 * Main data new API
 * Auto-generated openapi scheme for main-data-new API
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    ReadOnlyUserNested,
    ReadOnlyUserNestedFromJSON,
    ReadOnlyUserNestedFromJSONTyped,
    ReadOnlyUserNestedToJSON,
} from './';

/**
 * 
 * @export
 * @interface InlineResponse20047
 */
export interface InlineResponse20047 {
    /**
     * 
     * @type {number}
     * @memberof InlineResponse20047
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20047
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof InlineResponse20047
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<ReadOnlyUserNested>}
     * @memberof InlineResponse20047
     */
    results: Array<ReadOnlyUserNested>;
}

export function InlineResponse20047FromJSON(json: any): InlineResponse20047 {
    return InlineResponse20047FromJSONTyped(json, false);
}

export function InlineResponse20047FromJSONTyped(json: any, ignoreDiscriminator: boolean): InlineResponse20047 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(ReadOnlyUserNestedFromJSON)),
    };
}

export function InlineResponse20047ToJSON(value?: InlineResponse20047 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': ((value.results as Array<any>).map(ReadOnlyUserNestedToJSON)),
    };
}


